module.exports = __webpack_public_path__ + "media/btn_music.5b8dd532.mp3";